import { Injectable } from '@angular/core';
import { CanvasInputMode, CanvasInputModeService } from './canvas-input-mode.service';
import { CanvasService } from './canvas.service';
import { snapToGrid } from './connector/connector-utils';

@Injectable({ providedIn: 'root' })
export class PathEditService {
    constructor(
        private inputMode: CanvasInputModeService,
        private canvasService: CanvasService
    ) {
        this.init = this.init.bind(this);
    }

    init() {
        this.bindMouseEvents();
    }

    bindMouseEvents() {}

    removePoints() {
        const canvas: any = this.canvasService.getCanvas();
        const myNode = document.getElementById('pathpointgrip_container');
        myNode.innerHTML = '';
        canvas.pathActions.toSelectMode();
        this.inputMode.setMode(CanvasInputMode.SELECT);
    }

    scalePath(pathElement, newWidth, newHeight) {
        const canvas = this.canvasService.getCanvas();
        const svgRoot = canvas.getSvgRoot();
        const initialX = pathElement.getBBox().x;
        const initialY = pathElement.getBBox().y;

        const d = pathElement.getAttribute('d');
        const bbox = pathElement.getBBox();

        const pathWidth = bbox.width;
        const pathHeight = bbox.height;

        const scaleX = newWidth / pathWidth;
        const scaleY = newHeight / pathHeight;

        const newPath = d.replace(/([MLCQSZz])([^MLCQSZz]*)/g, (match, command, pointsStr) => {
            const points = pointsStr
                .trim()
                .split(/[\s,]+/)
                .map(Number);

            if (!points) return '';
            if (points?.length == 1 && points[0] == 0) return 'z';

            const scaledPoints = points.map((point, index) => {
                if (index % 2 === 0) {
                    return point * scaleX;
                } else {
                    return point * scaleY;
                }
            });

            return `${command} ${scaledPoints.join(' ')}`;
        });

        pathElement.setAttribute('d', newPath);

        const newX = pathElement.getBBox().x;
        const newY = pathElement.getBBox().y;

        if (initialY == newY && initialX == newX) return;

        let dx, dy;

        if (newX < initialX) {
            dx = initialX - newX;
        } else {
            dx = newX - initialX;
        }
        if (newY < initialY) {
            dy = initialY - newY;
        } else {
            dy = (newY - initialY) * -1;
        }
        if (canvas.curShape.gridSnapping) {
            dx = snapToGrid(0, canvas);
            dy = snapToGrid(0, canvas);
        }

        canvas.updateTransformList(svgRoot, pathElement, -dx, dy);
    }
}
